import Vue from 'vue'

Vue.component('ag-icon', require('./components/Icon.vue').default)
Vue.component('ag-logo', require('./components/Logo.vue').default)
Vue.component('ag-loading', require('./components/Loading.vue').default)

// Directives
Vue.directive('click-outside', require('./directives/clickOutside').default)
